<template>
  <div class="element-type" :class="{ selected: isSelected }" @click="$emit('on-select')">
    <BbIcon
      v-if="selectedPosition === 'left' && isSelected"
      class="element-type-selected-icon"
      size="small"
      name="checkmark-small"
    />
    <div class="element-type-name">
      <div>
        {{ title }}
        <span v-if="nrOfElements">{{ nrOfElements }}</span>
      </div>
      <div v-if="appliedFilterText" class="selected-label">
        <div>
          {{ appliedFilterText }}
        </div>
      </div>
    </div>
    <BbBtn
      v-if="selectedPosition === 'right'"
      :class="['arrow-button', { 'arrow-button-active': isSelected }]"
      size="x-small"
      type="icon"
      icon="chevron-right"
      icon-size="small"
      no-background
    />
  </div>
</template>

<script>
export default {
  props: {
    nrOfElements: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    appliedFilterText: {
      type: String,
      default: '',
    },
    selectedPosition: {
      type: String,
      default: '',
    },
  },
  emits: ['on-select'],
};
</script>

<style scoped lang="scss">
.element-type:hover {
  background-color: $bb-neutral-4;
}

.selected {
  background-color: $bb-neutral-4;
}

.element-type {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease;
  cursor: pointer;
  padding: 0 $bb-spacing-3;
  height: 44px;
  border-radius: 12px;

  &:hover {
    background-color: $bb-neutral-6;
  }

  .element-type-selected-icon {
    background-color: $bb-neutral-0;
    border-radius: 100px;
    margin-right: $bb-spacing-1;
  }

  .element-type-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    span {
      color: $bb-neutral-2;
    }

    @include bb-medium-text-styles('md');
    line-height: $bb-spacing-5;
    color: $bb-neutral-1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }

  .selected-label {
    border-radius: 8px;
    border: 1px solid $bb-neutral-2;
    background: $bb-neutral-0;
    height: 16px;
    display: flex;
    align-items: center;
    padding: 4px 8px;

    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      width: fit-content;
      font-size: 11px !important;
      font-style: normal;
      font-weight: 400;
      max-width: 50px;
    }
  }

  .arrow-button {
    border: none !important;

    :deep(.v-btn__content) {
      display: none;
    }

    &:hover {
      background: transparent !important;
    }
  }

  .arrow-button-active {
    :deep(.v-btn__content) {
      display: block;

      i {
        color: $bb-neutral-1;
      }
    }
  }
}
</style>
